import axiosPrivate from "./axiosPrivate";

const getContratosColaboradores = () => {
    return axiosPrivate.get("contrato-colaboradores").then(response => response);
};

export default {
    getContratosColaboradores
};